import { computed as e, createCommentVNode as t, createElementBlock as n, defineComponent as r, openBlock as i, toDisplayString as a } from "vue";
import { getResolvedRef as o } from "@scalar/workspace-store/helpers/get-resolved-ref";
//#region src/schema/SchemaCollapsedPreview.vue?vue&type=script&setup=true&lang.ts
var s = {
	key: 0,
	class: "property-collapsed-preview font-code text-c-1 max-w-max min-w-0 flex-1 basis-0 truncate text-(length:--scalar-mini)"
}, c = /*@__PURE__*/ r({
	__name: "SchemaCollapsedPreview",
	props: {
		schema: {},
		propertyNames: {},
		limit: { default: 3 }
	},
	setup(r) {
		let c = e(() => {
			if (!r.schema || typeof r.schema != "object") return null;
			let e = "properties" in r.schema ? r.schema : o(r.schema) ?? r.schema, t = r.propertyNames ?? (e && "properties" in e && e.properties ? Object.keys(e.properties) : []);
			if (t.length === 0) return null;
			let n = t.slice(0, r.limit), i = t.length - n.length;
			return `{ ${(i > 0 ? [...n, `+${i}`] : n).join(", ")} }`;
		});
		return (e, r) => c.value ? (i(), n("span", s, a(c.value), 1)) : t("", !0);
	}
});
//#endregion
export { c as default };

//# sourceMappingURL=SchemaCollapsedPreview.vue_vue_type_script_setup_true_lang.js.map